import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/min-main-logo.png';
var _hoisted_1 = { class: "find-scenic-food-detail" };
var _hoisted_2 = { class: "back-button" };
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "home-logo" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        alt: ""
    })
], -1);
var _hoisted_4 = { class: "main-title" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold");
    var _component_el_icon = _resolveComponent("el-icon");
    var _component_router_link = _resolveComponent("router-link");
    var _component_ScenicFoodInfoDetailContent = _resolveComponent("ScenicFoodInfoDetailContent");
    var _component_BaseLayout = _resolveComponent("BaseLayout");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_BaseLayout, null, {
            header: _withCtx(function () { return [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_icon, { onClick: _ctx.goBack }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_ArrowLeftBold)
                        ]; }),
                        _: 1
                    }, 8, ["onClick"])
                ]),
                _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(function () { return [
                        _hoisted_3
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$route.params.name), 1)
                ])
            ]; }),
            body: _withCtx(function () { return [
                _createVNode(_component_ScenicFoodInfoDetailContent)
            ]; }),
            _: 1
        })
    ]));
}
